import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import ReactHtmlParser from 'react-html-parser';


const Modal = props => {

    const { onClose, text, open } = props;

    const handleClose = () => {
        onClose(text);
    };
    return (
        <Dialog onClose={handleClose} open={open} >
            <div className='mod-content'>{ ReactHtmlParser(text) }</div>
        </Dialog>
    );
}

export default Modal;

